// ---------------------------------------------------------------------------
// Auth — recuperação de acesso ("esqueci minha senha", handoff 0098).
//
// Fluxo PÚBLICO de dois passos: pedir código de 6 dígitos por e-mail →
// confirmar código + senha nova. Não existe endpoint para validar o código
// isoladamente; a validação acontece no confirm, junto com a senha.
//
// FC1 §A.7: service desembrulha o sucesso (`data.data`) e NÃO trata erro — o
// `ApiError` já vem normalizado pelo interceptor de contrato.
//
// As duas rotas exigem header `Origin` permitido (mesma regra do /auth/login).
// O navegador manda sozinho; o saga de auth já sabe traduzir "Origem inválida".
// ---------------------------------------------------------------------------

import httpClient from '../axios';

/**
 * Passo 1 — pede o código de redefinição.
 *
 * ⚠️ A resposta é DELIBERADAMENTE cega: 200 com a mesma mensagem para e-mail
 * cadastrado, desconhecido, ou quando o próprio envio falha. A UI não pode
 * dizer "e-mail não encontrado" — isso transformaria o endpoint num oráculo de
 * quais e-mails têm conta no sistema (0098 §2).
 *
 * @param {string} email
 * @returns {Promise<{ message: string }>}
 */
export async function requestPasswordReset(email) {
   const response = await httpClient.post('/auth/password-reset/request', {
      email,
   });
   return { message: response?.data?.message ?? '' };
}

/**
 * Passo 2 — confirma o código e grava a senha nova.
 *
 * Sucesso revoga TODAS as sessões do usuário (`sessions_revoked: true`) — o
 * chamador deve limpar estado local antes de ir para o login.
 *
 * @param {object} params
 * @param {string} params.email
 * @param {string} params.code               6 dígitos, STRING (zero à esquerda
 *                                           é significativo — "042910")
 * @param {string} params.newPassword
 * @param {string} params.newPasswordConfirm
 * @returns {Promise<{ sessionsRevoked: boolean, message: string }>}
 */
export async function confirmPasswordReset({
   email,
   code,
   newPassword,
   newPasswordConfirm,
}) {
   // camel → snake só aqui, na margem do service (FC1 §A.7).
   const response = await httpClient.post('/auth/password-reset/confirm', {
      email,
      code: String(code),
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
   });

   return {
      sessionsRevoked: Boolean(response?.data?.data?.sessions_revoked),
      message: response?.data?.message ?? '',
   };
}
